import LabeledSelect from "./LabeledSelect";
import {debounce, isEmpty} from "lodash";
import {getCategory, searchCategory} from "../../redux/sagas/requests/categoryService";
import {useCallback, useEffect, useState} from "react";

const CategorySearchSelect = ({
                                label, value, onChange, placeholder = "Search categories",
                                emptyMsg = "No data", extData,...props
                              }) => {


  //todo search a better way to load default values
  const [isFetching, setIsFetching] = useState(false);



  useEffect(() => {
    if (extData && !value && !isFetching && onChange){
      // const selected = data.find((d)=>d.id === extData);
      // if(onChange){
      //   onChange(selected);
      // }
      setIsFetching(true);
      getCategory(extData).then((resp)=>{
        setIsFetching(false);
        onChange(resp.data);
      }).catch((err)=>{
        setIsFetching(false);
      });

    }

  }, [extData]);


  // noinspection JSCheckFunctionSignatures
  const debouncedSearchCategory = useCallback(
    debounce((inputText, callback) => {
      handleSearchCategory(inputText).then((options) => callback(options));
    }, 500),
    [handleSearchCategory]
  );


  return (
    <LabeledSelect label={label} value={value} getOptionLabel={(option) => option.name} loading={isFetching} isDisabled={isFetching}
                   getOptionValue={(option) => option.id} placeholder={placeholder}
                   onChange={onChange} emptyMsg={emptyMsg} {...props} loadOptions={debouncedSearchCategory}/>
  );


};

export default CategorySearchSelect;


const handleSearchCategory = (input) => {
  if (isEmpty(input)) {
    return [];
  }

  return searchCategory(input).then((response) =>
    response.data?.Categories ? response.data.Categories : []
  );

};